<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <div>
    <app-form-control label="Nowa cena">
      <p-input-number
        [fluid]="true"
        [formControl]="form.controls.price"
        [min]="0"
        currency="PLN"
        mode="currency"
        placeholder="Wprowadź nową cenę boxa w subskrypcji" />
    </app-form-control>
  </div>

  <div class="mt-auto flex justify-end">
    <p-button
      [disabled]="form.invalid"
      appPrimengButton
      label="Zapisz"
      severity="primary"
      type="submit" />
  </div>
</form>
